<div class="floori-dialog-wrapper">
    <ng-template cdkPortalOutlet></ng-template>
</div>

